var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("span.error {\n  color: red;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _vueFormWizard = require("vue-form-wizard");

var _vueFormWizard2 = _interopRequireDefault(_vueFormWizard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.use(_vueFormWizard2.default);

exports.default = {
  data: function data() {
    return {
      services: null,
      selected_service: [],
      fname_error: null,
      lname_error: null,
      idno_error: null,
      phone_error: null,
      errorMsg: null,
      customerForm: {
        fname: null,
        lname: null,
        idno: null,
        phone: null
      },
      consumer_secret: null,
      consumer_key: null,
      api_token: null,
      merchant_id: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    this.merchant_id = this.$attrs["merchant_id"];
    this.getOauthToken();
    $("#newCustomerModal").on("hidden.bs.modal", function () {
      _this.reset();
    });
  },
  created: function created() {
    this.services = this.loadAvailableServices();
  },
  computed: {
    checkedNames: function checkedNames() {
      if (this.services) {
        return this.services.filter(function (item) {
          return item.checked;
        }).map(function (name) {
          return name.name;
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    getOauthToken: function getOauthToken() {
      var _this2 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.api_token = response.data.token;
        _this2.banks = _this2.loadBanks();
      }).catch(function (error) {}).then(function () {});
    },
    reset: function reset() {
      this.services = null;
      this.selected_service = [];
      this.fname_error = null;
      this.lname_error = null;
      this.idno_error = null;
      this.phone_error = null;
      this.customerForm = {
        fname: null,
        lname: null,
        idno: null,
        phone: null
      };
    },
    validateCustomerDetails: function validateCustomerDetails() {
      if (this.customerForm.fname && this.customerForm.lname && this.customerForm.idno && this.customerForm.phone) {
        return true;
      }
      this.fname_error = null;
      this.lname_error = null;
      this.idno_error = null;
      this.phone_error = null;

      if (!this.customerForm.fname) {
        this.fname_error = "* required";
      }
      if (!this.customerForm.lname) {
        this.lname_error = "* required";
      }
      if (!this.customerForm.idno) {
        this.idno_error = "* required";
      }
      if (!this.customerForm.phone) {
        this.phone_error = "* required";
      }
      return false;
    },


    loadAvailableServices: function loadAvailableServices() {
      return [{ id: 1, name: "Deposit Cash" }, { id: 2, name: "Withdraw Cash" }, { id: 3, name: "Apply for Driving Licence" }, { id: 4, name: "Apply for Business Permit" }, { id: 5, name: "Apply for eVisa" }];
    },

    create_customer: function create_customer() {
      var urlIs = "/api/agent/customer/new";
      var api_headers = { Authorization: "Bearer " + this.api_token };
      var api_params = {
        first_name: this.customerForm.fname,
        last_name: this.customerForm.lname,
        id_number: this.customerForm.idno,
        msisdn: this.customerForm.phone,
        merchant_id: this.merchant_id
      };
      Vue.axios.post(urlIs, api_params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Ensure the customer is not already created"
          });
        } else {
          $("#newCustomerModal .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Customer has been created",
            showConfirmButton: false,
            timer: 4500
          });
          location.reload();
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    },
    onComplete: function onComplete() {
      this.create_customer();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-primary lift",attrs:{"href":"#","data-toggle":"modal","data-target":"#newCustomerModal"}},[_vm._v("New Customer")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"newCustomerModal","tabindex":"-1","role":"dialog","aria-labelledby":"newCustomerModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',[_c('form-wizard',{attrs:{"color":"#9b59b6","error-color":"#ff4949"},on:{"on-complete":_vm.onComplete}},[_c('h2',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Complete this form")]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Customer details","icon":"ti-user","before-change":_vm.validateCustomerDetails}},[_c('form',{ref:"ruleForm",attrs:{"model":_vm.customerForm,"rules":_vm.rules}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"staticEmail"}},[_vm._v("FirstName")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.fname),expression:"customerForm.fname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"John"},domProps:{"value":(_vm.customerForm.fname)},on:{"focus":_vm.validateCustomerDetails,"blur":_vm.validateCustomerDetails,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "fname", $event.target.value)}}}),_vm._v(" "),(_vm.fname_error)?_c('span',{staticClass:"error"},[_vm._v("* required")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"staticEmail"}},[_vm._v("LastName")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.lname),expression:"customerForm.lname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Doe"},domProps:{"value":(_vm.customerForm.lname)},on:{"focus":_vm.validateCustomerDetails,"blur":_vm.validateCustomerDetails,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "lname", $event.target.value)}}}),_vm._v(" "),(_vm.lname_error)?_c('span',{staticClass:"error"},[_vm._v("* required")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"staticEmail"}},[_vm._v("IDNumber")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.idno),expression:"customerForm.idno"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"11111111"},domProps:{"value":(_vm.customerForm.idno)},on:{"focus":_vm.validateCustomerDetails,"blur":_vm.validateCustomerDetails,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "idno", $event.target.value)}}}),_vm._v(" "),(_vm.idno_error)?_c('span',{staticClass:"error"},[_vm._v("* required")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"staticEmail"}},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customerForm.phone),expression:"customerForm.phone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"254XXXYYYZZZ"},domProps:{"value":(_vm.customerForm.phone)},on:{"focus":_vm.validateCustomerDetails,"blur":_vm.validateCustomerDetails,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customerForm, "phone", $event.target.value)}}}),_vm._v(" "),(_vm.phone_error)?_c('span',{staticClass:"error"},[_vm._v("* required")]):_vm._e()])])])])],1)],1)]),_vm._v(" "),_vm._m(1)])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Add New Customer")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-66fe2f66", __vue__options__)
  } else {
    hotAPI.reload("data-v-66fe2f66", __vue__options__)
  }
})()}